import React, { FunctionComponent } from 'react';

import styles from './active-job-offerts.module.scss';
import {
  IJobOffertItemProps,
  JobOffertItem
} from './job-offert-item/job-offert-item';
import { IElevatoListItem } from '../../templates/page';

export interface IActiveJobOffertsProps {
  headerValue: string;
  applyButtonText: string;
  jobOffersElevato: IElevatoListItem[];
}

export const ActiveJobOfferts: FunctionComponent<IActiveJobOffertsProps> = ({
  headerValue,
  applyButtonText,
  jobOffersElevato
}) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.header}>{headerValue}</div>
      <div className={styles.jobOfeerts}>
        {jobOffersElevato &&
          jobOffersElevato.map((jobOffert: IJobOffertItemProps, i: number) => (
            <JobOffertItem
              title={jobOffert.title}
              jobLocation={jobOffert.jobLocation}
              buttonText={applyButtonText}
              key={i}
            />
          ))}
      </div>
    </div>
  );
};
